import { ChangeDetectionStrategy, Component, inject, input, signal, output } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import {
  WorkflowPermissionDetailsAssigneeSteps,
  WorkflowPermissionDetailsAssigneeTabList,
} from '../../../workflow.model';
import { PaginatorComponent } from '../../../../../../../ui-components/lib/paginator/paginator.component';
import { AvatarComponent } from '../../../../../../../ui-components/lib/avatar/avatar.component';
import { BadgeComponent } from '../../../../../../../ui-components/lib/badge/badge.component';
import { TableComponent } from '../../../../../../../ui-components/lib/table/table.component';
import { TruncatePipe } from '../../../../../../../ui-components/pipes/truncate/truncate.pipe';
import { TableColumns } from '../../../../../../../ui-components/lib/table/table.model';
import { DEFAULT_PAGE_SIZE_OPTIONS } from '../../../../../../common/constants/pagination.constants';

@Component({
  selector: 'lib-workflow-details-assignee-table-view',
  imports: [
    TranslocoPipe,
    AvatarComponent,
    TruncatePipe,
    TableComponent,
    BadgeComponent,
    PaginatorComponent,
  ],
  templateUrl: './workflow-details-assignee-table-view.component.html',
  styleUrl: './workflow-details-assignee-table-view.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class WorkflowDetailsAssigneeTableViewComponent {
  readonly pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS;

  transloco = inject(TranslocoService);
  isLoading = input<boolean>(false);
  currentPage = signal<number>(1);
  currentSize = signal<number>(25);
  totalPages = input<number>(2);
  paginationEmitter = output<{ currentPage: number; currentSize: number }>();
  totalAssigneeCount = input<string>('');
  assigneeTotalCountEmitter = output<string>();

  tableData = input<WorkflowPermissionDetailsAssigneeTabList[]>([]);
  columns: TableColumns[] = [
    { header: '', field: '' },
    {
      header: this.transloco.translate(
        'workflow_permission_details_assignee_list_screen_assignee_table_header'
      ),
      field: '',
    },
    {
      header: this.transloco.translate(
        'workflow_permission_details_assignee_list_screen_step_name_table_header'
      ),
      field: '',
    },
  ];

  handleTemplateSteps(steps: WorkflowPermissionDetailsAssigneeSteps[]) {
    const mappedSteps = steps.map(ele => ele.name);
    return mappedSteps.join(' , ');
  }

  handlePagination($event: number) {
    this.currentPage.set($event);
    this.paginationEmitter.emit({
      currentPage: this.currentPage(),
      currentSize: this.currentSize(),
    });
  }

  changeSize($event: number) {
    this.currentSize.set($event);
    this.currentPage.set(1);
    this.paginationEmitter.emit({
      currentPage: this.currentPage(),
      currentSize: this.currentSize(),
    });
  }
}
